var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextField(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_text-line-solid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.85713 11.4286C2.19865 11.4286 1.66666 11.9606 1.66666 12.6191C1.66666 13.2775 2.19865 13.8095 2.85713 13.8095H9.99999C10.6585 13.8095 11.1905 13.2775 11.1905 12.6191C11.1905 11.9606 10.6585 11.4286 9.99999 11.4286L2.85713 11.4286ZM2.85713 6.66669C2.19865 6.66669 1.66666 7.19868 1.66666 7.85716C1.66666 8.51565 2.19865 9.04764 2.85713 9.04764H17.1428C17.8013 9.04764 18.3333 8.51565 18.3333 7.85716C18.3333 7.19868 17.8013 6.66669 17.1428 6.66669H2.85713Z",
    fill: "#B4B4B4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextField);
export default __webpack_public_path__ + "static/media/text-field.b7d0f0fa6b4f7703aa0d63413a34bc0f.svg";
export { ForwardRef as ReactComponent };